// WW-190 · venue / curator delete stays open until 7 Nov 2026 23:59 Nairobi; the server is the judge.
import { useEffect, useState } from "react";
import { client } from "@/lib/api";

export function useDeleteWindow() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    client.get("/admin/venues/meta/delete-window").then((r) => setOpen(!!r.data.open)).catch(() => setOpen(false));
  }, []);
  return open;
}
